import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { is } from 'ramda';
import React from 'react';

import { CONSTANTS } from '../../../../core/config/constants';
import { CompanyOwnershipInfo } from '../../../../generated/model/models';

interface Props extends ICellRendererParams {}

const TopShareHoldersCellRenderer: React.FC<Props> = ({ value }) => {
  const text: string[] = [];

  if (value && is(Array, value)) {
    value.forEach((item: CompanyOwnershipInfo) => {
      if (is(Object, item) && is(Number, item.shares)) {
        text.push(
          `${item.ownerName ?? CONSTANTS.UNKNOWN_NAME} ${item.shares}${CONSTANTS.PERCENT_SYMBOL}`,
        );
      }
    });
  }

  return <>{text.join(CONSTANTS.RENDERER_ARRAY_SEPARATOR)}</>;
};

export default TopShareHoldersCellRenderer;
